export default __webpack_public_path__ + "static/media/assigning.8161ec19.svg";